const DATE_FORMAT = {
    ISO8001: "YYYY-MM-DD",
    LOCALE: "MM/DD/YYYY",
    APP: "MM-DD-YYYY",
    LOCALE_TIME: "MM/DD/YYYY h:mm:ss a"
}

export {
    DATE_FORMAT
}